import { rawVestaContract } from '.';
import { proxyNetworkProvider, resultsParser } from '..';

export const getFirstSnapshotEpoch = async () => {
  const query = rawVestaContract.methods
    .getFirstSnapshotEpoch()
    .check()
    .buildQuery();
  const response = await proxyNetworkProvider.queryContract(query);
  const { firstValue, returnCode } = resultsParser.parseQueryResponse(
    response,
    rawVestaContract.getEndpoint('getFirstSnapshotEpoch')
  );
  if (!returnCode.isSuccess()) {
    return -1;
  } else {
    return firstValue?.valueOf().toNumber() ?? -1;
  }
};
